const trustItems = [
  { icon: 'ri-calendar-check-fill', value: '35+', label: 'Years in Business', sub: 'Serving Chicago since 1989' },
  { icon: 'ri-star-fill', value: '5.0', label: 'Customer Rating', sub: 'Consistent 5-star feedback' },
  { icon: 'ri-shield-check-fill', value: '100%', label: 'Licensed & Insured', sub: 'Illinois certified contractor' },
  { icon: 'ri-home-heart-fill', value: 'Family', label: 'Owned & Operated', sub: 'Wayne Christo & team' },
  { icon: 'ri-map-pin-2-fill', value: '24+', label: 'Communities Served', sub: 'Chicago & Chicagoland suburbs' },
  { icon: 'ri-file-text-fill', value: 'Free', label: 'Written Estimates', sub: 'No obligation inspections' },
];

export default function TrustBar() {
  return (
    <section className="bg-brand-dark border-b border-white/5 relative overflow-hidden">
      {/* Subtle grid texture */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: 'repeating-linear-gradient(0deg, #c9a227 0, #c9a227 1px, transparent 0, transparent 60px), repeating-linear-gradient(90deg, #c9a227 0, #c9a227 1px, transparent 0, transparent 60px)' }}
      />
      {/* Gold accent bar at top */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-brand-gold to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 lg:gap-4">
          {trustItems.map((item, idx) => (
            <div
              key={item.label}
              className="flex flex-col items-center text-center gap-2.5 group"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              {/* Icon circle */}
              <div className="relative w-12 h-12 flex items-center justify-center">
                <div className="absolute inset-0 bg-brand-gold/10 rounded-full group-hover:bg-brand-gold/20 transition-colors duration-300" />
                <i className={`${item.icon} text-brand-gold text-xl relative z-10`} />
              </div>
              {/* Value + label */}
              <div>
                <div className="font-display text-2xl font-bold text-white leading-none">{item.value}</div>
                <div className="text-xs font-bold text-brand-gold uppercase tracking-wider mt-1">{item.label}</div>
                <div className="text-xs text-gray-500 mt-0.5 leading-tight">{item.sub}</div>
              </div>
              {/* Vertical divider (except last) */}
              {idx < trustItems.length - 1 && (
                <div className="hidden lg:block absolute right-0 top-1/4 bottom-1/4 w-px bg-white/5" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Gold accent bar at bottom */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" />
    </section>
  );
}
